import { Flex } from "@songtradr-sso/shared/frontend";
import {
  Body,
  Drawer,
  DropdownDivider,
  Heading,
} from "@songtradr/design-language";
import {
  Info,
  LightbulbIcon,
  NoWorkspace,
  Number,
  Props,
  Tip,
  text,
} from "./HelpPanel.Parts";

export const HelpPanel = (props: Props) => {
  const renderTips = () =>
    text.tips.map((tip, index) => (
      <Flex key={index} $gap="1rem">
        <Number variant="h3-strong">{index + 1}</Number>
        <Tip>{tip}</Tip>
      </Flex>
    ));

  return (
    <Drawer {...props} title={text.title} hideTitle>
      <Flex $flow="column">
        <Flex $flow="column">
          <Heading variant="h3-strong">{text.title}</Heading>
          <Body variant="normal-strong">{text.description}</Body>
        </Flex>
        <DropdownDivider />
        {renderTips()}
        <Info>
          <LightbulbIcon width="2rem" height="2rem" />
          <Body>{text.info}</Body>
        </Info>
        {/**@todo add back in and remove below after AuxClients is removed! */}
        {/* <NoWorkspace as={Link} to={routes.base}>
          {text.noWorkspace}
        </NoWorkspace> */}
        <NoWorkspace
          href="https://studio.songtradr.com/login"
          rel="noopener noreferrer"
        >
          {text.tempLookingForStudio}
        </NoWorkspace>
      </Flex>
    </Drawer>
  );
};
